import PropTypes from 'prop-types';
import classnames from 'classnames';
import React from 'react';
import styles from './Ripple.css';

const Ripple = ({ version = 'fill' }) => {
  const [ripple, setRipple] = React.useState(null);
  const timeoutRef = React.useRef();

  const handleTouchStart = e => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    const touch = e.touches[0] || e.changedTouches[0];
    // Position the circle so it's center is at the touch point
    const rect = e.target.getBoundingClientRect();
    const x = touch.clientX - rect.left;
    const y = touch.clientY - rect.top;
    const diameter = Math.max(rect.width, rect.height);

    // Generate a random id so we can use it as a React key
    setRipple({ x, y, diameter, id: Math.floor(Math.random() * 1000000) });
    timeoutRef.current = setTimeout(() => {
      setRipple(null);
    }, 600);
  };

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  if (!__CAPACITOR__) {
    return null;
  }

  return (
    <div className={classnames(styles.wrapper, styles[version])} onTouchStart={handleTouchStart}>
      {ripple && (
        <div
          key={ripple.id}
          className={styles.ripple}
          style={
            version === 'fill'
              ? {
                  left: ripple.x - ripple.diameter / 2,
                  top: ripple.y - ripple.diameter / 2,
                  width: ripple.diameter,
                  height: ripple.diameter,
                }
              : {}
          }
        />
      )}
    </div>
  );
};

Ripple.propTypes = {
  version: PropTypes.string,
};

export default Ripple;
